import React, { Component } from 'react';
import Odontogram from './Odontogram';
import odontograms from '../../../component/images/odontogram';
import Card from '../../../component/Card';
import './odontogram.css';

export class OdontogramSet extends Component {
  renderOdontogram = (
    odontogramData,
    length,
    src,
    alt,
    element = 0,
    asc = true
  ) => {
    let thisElement = element;
    const render = [ ...new Array(length) ];
    return render.map(i => {
      const newElement = asc ? thisElement++ : thisElement--;
      return (
        <Odontogram
          statusImage={
            odontogramData.hasOwnProperty(newElement)
              ? odontogramData[ newElement ][ '0' ].url
              : src
          }
          key={ newElement }
          element={ newElement }
          src={ src }
          alt={ alt }
          readOnly={this.props.readOnly}
        />
      );
    });
  };

  render() {
    const odontogramData = this.props.odontogramData;
    return (
      <div>
        <Card.ModuleHeader header='Odontogram' />
        <div className='table-responsive mt-2'>
          <table align='center' className='odontogram'>
            <tbody>
              <tr>
                {this.renderOdontogram(
                  odontogramData,
                  5,
                  odontograms.normal.src,
                  odontograms.normal.alt,
                  18,
                  false
                )}
                {this.renderOdontogram(
                  odontogramData,
                  3,
                  odontograms.normal2.src,
                  odontograms.normal2.alt,
                  13,
                  false
                )}
                <td className='empty'></td>
                {this.renderOdontogram(
                  odontogramData,
                  3,
                  odontograms.normal2.src,
                  odontograms.normal2.alt,
                  21
                )}
                {this.renderOdontogram(
                  odontogramData,
                  5,
                  odontograms.normal.src,
                  odontograms.normal.alt,
                  24
                )}
              </tr>
              <tr>
                <td colSpan='3'></td>
                {this.renderOdontogram(
                  odontogramData,
                  2,
                  odontograms.normal.src,
                  odontograms.normal.alt,
                  55,
                  false
                )}
                {this.renderOdontogram(
                  odontogramData,
                  3,
                  odontograms.normal2.src,
                  odontograms.normal2.alt,
                  53,
                  false
                )}
                <td className='empty'></td>
                {this.renderOdontogram(
                  odontogramData,
                  3,
                  odontograms.normal2.src,
                  odontograms.normal2.alt,
                  61
                )}
                {this.renderOdontogram(
                  odontogramData,
                  2,
                  odontograms.normal.src,
                  odontograms.normal.alt,
                  64
                )}
              </tr>
              <tr>
                <td colSpan='3'></td>
                {this.renderOdontogram(
                  odontogramData,
                  2,
                  odontograms.normal.src,
                  odontograms.normal.alt,
                  85,
                  false
                )}
                {this.renderOdontogram(
                  odontogramData,
                  3,
                  odontograms.normal2.src,
                  odontograms.normal2.alt,
                  83,
                  false
                )}
                <td className='empty'></td>
                {this.renderOdontogram(
                  odontogramData,
                  3,
                  odontograms.normal2.src,
                  odontograms.normal2.alt,
                  71
                )}
                {this.renderOdontogram(
                  odontogramData,
                  2,
                  odontograms.normal.src,
                  odontograms.normal.alt,
                  74
                )}
              </tr>
              <tr>
                {this.renderOdontogram(
                  odontogramData,
                  5,
                  odontograms.normal.src,
                  odontograms.normal.alt,
                  48,
                  false
                )}
                {this.renderOdontogram(
                  odontogramData,
                  3,
                  odontograms.normal2.src,
                  odontograms.normal2.alt,
                  43,
                  false
                )}
                <td className='empty'></td>
                {this.renderOdontogram(
                  odontogramData,
                  3,
                  odontograms.normal2.src,
                  odontograms.normal2.alt,
                  31
                )}
                {this.renderOdontogram(
                  odontogramData,
                  5,
                  odontograms.normal.src,
                  odontograms.normal.alt,
                  34
                )}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default OdontogramSet;
